/* eslint-disable react-hooks/exhaustive-deps */
import {
  CaretDownOutlined,
  LoadingOutlined,
  LogoutOutlined,
  MenuOutlined,
  TranslationOutlined,
  UserOutlined,
} from '@ant-design/icons';
import {
  Badge,
  Button,
  Checkbox,
  Drawer,
  Layout,
  Menu,
  Modal,
  Popover,
  Select,
} from 'antd';
import { Steps as StepsIntro } from 'intro.js-react';
import 'intro.js/introjs.css';
import moment from 'moment';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import CarNotification from '../../assets/icons/car_noti.svg';
import KnifeNotification from '../../assets/icons/knife_noti.svg';
import MainLogo from '../../assets/icons/main_logo.svg';
import DashLogo from '../../assets/icons/dash_logo.png';
import HoasenLogo from '../../assets/icons/hoasen_home_logo.svg';
import MotobikeNotification from '../../assets/icons/motobike_noti.svg';
import PeopleNotification from '../../assets/icons/people_notif.svg';
import SungNotification from '../../assets/icons/sung_noti.svg';
import IntroStart from '../../assets/images/intro-start.png';
import IntroTabCamera from '../../assets/images/intro-tab-camera.png';
import * as SERVICE from '../../constants/service.types';
import * as SYSTEM from '../../constants/system.keys';
import { PINNED_CAMERAS } from '../../constants/system.keys';
import * as ACTIONS from '../../redux/actions';
import {
  changeLocales,
  resetCameraByPageReturn,
  socketEmitEvent,
} from '../../redux/actions';
import { resetDataToken } from '../../redux/socket';
import NotificationComponent from './Notifications';

const { Option } = Select;
const { Header } = Layout;
const HOSTNAME = window.location.hostname;
const LOGO = {
  'cloudcam.dashhome.vn': DashLogo,
  'cloudcam1.hoasengroup.vn': HoasenLogo,
};

const AppHeader = withRouter(({ location, isShowNotif, setIsShowNotif }) => {
  const { t } = useTranslation();

  const dispatch = useDispatch();
  const {
    isAuth,
    dataUser,
    language: localLanguage,
    namespace,
    totalNotifications,
    markUnreadNotifications,
    userId,
    notificationDetail,
    actionLogId,
    lastVisited,
  } = useSelector((state) => state);
  const [visibleUserControl, setVisibleUserControl] = useState(false);
  const [user, setUser] = useState(dataUser);
  const [markUnread, setMarkUnread] = useState();

  const [language, setLanguage] = useState();
  const [visible, setVisible] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [visibleNotification, setVisibleNotification] = useState(false);
  const [keyNotification, setKeyNotification] = useState(Math.random());
  const [dataSteps, setDataSteps] = useState([
    {
      element: '.tab-camera',
      intro: (
        <div>
          <img
            alt=""
            style={{ width: '100%', marginBottom: '8px' }}
            src={IntroTabCamera}
          />
          <div>{t('Click vào tab "Camera"')}</div>
        </div>
      ),
    },
  ]);
  const [stepsEnabled, setStepsEnabled] = useState(false);
  const [initialStep, setInitialStep] = useState(0);
  const [isModalVisibleStart, setIsModalVisibleStart] = useState(false);

  useEffect(() => {
    if (dataUser) {
      if (!lastVisited) {
        setTimeout(() => {
          showModalStart();
        }, 500);
      }
    }
  }, [dataUser]);

  useEffect(() => {
    if (localLanguage) {
      setLanguage(localLanguage);
    }
  }, [localLanguage]);
  const handleUpdateLanguage = useCallback(
    (lang) => {
      setLanguage(lang);
      dispatch(changeLocales(lang));
      window.location.reload(false);
    },
    [dispatch]
  );

  useEffect(() => {
    if (markUnreadNotifications) {
      setMarkUnread(0);
    }
  }, [markUnreadNotifications]);

  useEffect(() => {
    let requestId = new Date().getTime();
    if (isAuth === 1 && namespace) {
      let data = {
        timeRequested: requestId,
        page: 0,
        namespace,
      };
      let dataObj = {
        appServiceType: SERVICE.LIST_NOTIFICATION,
        requestId,
        body: JSON.stringify(data),
      };
      dispatch(socketEmitEvent(dataObj));
    }
  }, [dispatch, isAuth, namespace, keyNotification]);

  const getLogoIcon = useMemo(() => {
    return LOGO[HOSTNAME] || MainLogo;
  }, []);

  const listNotifcations = useMemo(() => {
    const content = (
      <>
        <NotificationComponent />
        <div
          style={{
            marginTop: '10px',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <Link to="/system" onClick={() => setKeyNotification(Math.random())}>
            <div
              style={{
                cursor: 'pointer',
                color: '#c8c8c8',
                fontWeight: 'bold',
              }}
              className="all-notifications"
            >
              {t('All notifications')}
            </div>
          </Link>
          <div
            style={{
              cursor: 'pointer',
              color: '#c8c8c8',
              fontWeight: 'bold',
            }}
            className="all-notifications"
          >
            <Checkbox
              checked={isShowNotif}
              onChange={(e) => {
                setIsShowNotif(e.target.checked);
                dispatch(ACTIONS.setShowCritical(e.target.checked));
              }}
            >
              {t('Critical events')}
            </Checkbox>
          </div>
        </div>
      </>
    );
    return content;
  }, [isShowNotif]);

  useEffect(() => {
    if (isAuth === 1 && namespace && !dataUser) {
      let dataBody = {
        namespace,
      };
      let dataObj = {
        appServiceType: SERVICE.GET_USER_INFO,
        requestId: new Date().getTime(),
        body: JSON.stringify(dataBody),
      };
      dispatch(socketEmitEvent(dataObj));
    }
  }, [dataUser, dispatch, isAuth, namespace]);

  useEffect(() => {
    if (namespace) {
      let dataBody = {
        namespace,
      };
      if (actionLogId) {
        dataBody.actionLogId = actionLogId;
      }
      let dataObj = {
        appServiceType: SERVICE.CHOOSE_NAMESPACE,
        requestId: new Date().getTime(),
        body: JSON.stringify(dataBody),
      };
      dispatch(socketEmitEvent(dataObj));
    }
  }, [dispatch, namespace]);

  useEffect(() => {
    if (notificationDetail) {
      showModal();
    }
  }, [notificationDetail]);

  const functionLogout = useCallback(() => {
    let data = {
      clientId: localStorage.getItem('onesignal_userId'),
      bundleId: 'camera.beex.vn',
      namespace,
    };
    let dataObj = {
      appServiceType: SERVICE.UNREGISTER_NOTIFICATION,
      requestId: new Date().getTime(),
      body: JSON.stringify(data),
    };
    dispatch(socketEmitEvent(dataObj));
    resetDataToken();
    dispatch(ACTIONS.authLogoutThunk());
    // let hashKey = `${PINNED_CAMERAS}.${namespace}.${userId}`;

    // localStorage.removeItem(hashKey);
    localStorage.removeItem(SYSTEM.GOOGLE_CLIENT_ID);
    localStorage.removeItem(SYSTEM.GOOGLE_NAMESPACE);
    localStorage.removeItem(SYSTEM.GOOGLE_USERNAME);
  });

  useEffect(() => {
    if (dataUser) {
      setUser(dataUser);
    }
  }, [dataUser]);

  const showDrawer = () => {
    setVisible(true);
  };
  const onClose = () => {
    setVisible(false);
  };

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
    dispatch(ACTIONS.getNewNotificationDetailReturn(null));
  };

  const showModalStart = () => {
    setIsModalVisibleStart(true);
  };

  const handleOkStart = () => {
    setIsModalVisibleStart(false);
    localStorage.setItem('tutorial', '1');
    setTimeout(() => {
      setStepsEnabled(true);
    }, 300);
  };

  const handleCancelStart = () => {
    setIsModalVisibleStart(false);
    localStorage.setItem('tutorial', '0');
  };

  const contentNotification = (item) => {
    var temple = '';
    switch (item.type) {
      case 'event_object_detection':
        let array_object =
          item.extraInfo &&
          JSON.parse(item.extraInfo) &&
          JSON.parse(item.extraInfo).objects &&
          JSON.parse(item.extraInfo).objects.split(',');
        let key_object = {};
        array_object &&
          array_object.forEach((e) => {
            if (e == 'car') {
              key_object.car = true;
            }
            if (e == 'motor') {
              key_object.motor = true;
            }
            if (e == 'gun') {
              key_object.gun = true;
            }
            if (e == 'knife') {
              key_object.knife = true;
            }
            if (e == 'person') {
              key_object.person = true;
            }
          });
        temple = (
          <div>
            <span>{item.content}</span>
            {key_object.person ? (
              <img
                alt=""
                style={{ marginLeft: '10px' }}
                src={PeopleNotification}
              />
            ) : (
              ''
            )}
            {key_object.car ? (
              <img alt="" style={{ marginLeft: '5px' }} src={CarNotification} />
            ) : (
              ''
            )}
            {key_object.knife ? (
              <img
                alt=""
                style={{ marginLeft: '5px' }}
                src={KnifeNotification}
              />
            ) : (
              ''
            )}
            {key_object.motor ? (
              <img
                alt=""
                style={{ marginLeft: '5px' }}
                src={MotobikeNotification}
              />
            ) : (
              ''
            )}
            {key_object.knife ? (
              <img
                alt=""
                style={{ marginLeft: '5px' }}
                src={SungNotification}
              />
            ) : (
              ''
            )}
          </div>
        );
        break;
      case 'update_system':
        temple = <span>{t('System upgrade schedule')}</span>;
        break;
      default:
        temple = <span>{item.content}</span>;
    }
    return temple;
  };
  return (
    <Header className="header">
      <div className="logo">
        <div className="icon">
          <img style={{ width: '50px' }} alt="logo" src={getLogoIcon} />
        </div>
      </div>
      <Menu
        theme="dark"
        mode="horizontal"
        className="menu-header-desktop"
        selectedKeys={[location.pathname]}
        style={{ lineHeight: '64px' }}
      >
        <Menu.Item key="/">
          <Link to="/">{t('Dashboard')}</Link>
        </Menu.Item>
        <Menu.Item key="/gateway">
          <Link to="/gateway">{t('Gateway')}</Link>
        </Menu.Item>
        <Menu.Item key="/live">
          <Link to="/live">{t('Live')}</Link>
        </Menu.Item>
        <Menu.Item key="/camera">
          <Link
            onClick={() => dispatch(resetCameraByPageReturn())}
            className="tab-camera"
            to="/camera"
          >
            {t('Camera')}
          </Link>
        </Menu.Item>
        <Menu.Item key="/playback">
          <Link to="/playback" onClick={() => onClose()}>
            {t('Playback')}
          </Link>
        </Menu.Item>
        <Menu.Item key="/shares">
          <Link to="/shares">{t('Share')}</Link>
        </Menu.Item>
        <Menu.Item key="/service">
          <Link to="/service">{t('Service')}</Link>
        </Menu.Item>
        <Menu.Item key="/report">
          <Link to="/report">{t('Statistical')}</Link>
        </Menu.Item>
        <Menu.Item key="/system">
          <Link to="/system">{t('System')}</Link>
        </Menu.Item>
      </Menu>
      <Drawer
        className="drawer-header"
        placement="right"
        onClose={onClose}
        visible={visible}
        width="70%"
      >
        <Menu
          theme="dark"
          selectedKeys={[location.pathname]}
          style={{ lineHeight: '64px', marginTop: '20px' }}
        >
          <Menu.Item key="/">
            <Link to="/" onClick={() => onClose()}>
              {t('Dashboard')}
            </Link>
          </Menu.Item>
          <Menu.Item key="/gateway">
            <Link to="/gateway" onClick={() => onClose()}>
              {t('Gateway')}
            </Link>
          </Menu.Item>
          <Menu.Item key="/live">
            <Link to="/live" onClick={() => onClose()}>
              {t('Live')}
            </Link>
          </Menu.Item>
          <Menu.Item key="/camera">
            <Link to="/camera" onClick={() => onClose()}>
              {t('Camera')}
            </Link>
          </Menu.Item>
          <Menu.Item key="/shares">
            <Link to="/shares" onClick={() => onClose()}>
              {t('Share')}
            </Link>
          </Menu.Item>
          <Menu.Item key="/service">
            <Link to="/service" onClick={() => onClose()}>
              {t('Service')}
            </Link>
          </Menu.Item>
          <Menu.Item key="/report">
            <Link to="/report" onClick={() => onClose()}>
              {t('Statistical')}
            </Link>
          </Menu.Item>
          <Menu.Item key="/system">
            <Link to="/system" onClick={() => onClose()}>
              {t('System')}
            </Link>
          </Menu.Item>
        </Menu>
      </Drawer>
      <div
        className="header-popover-notification"
        style={{
          right:
            user?.fullName?.length > 8
              ? user?.fullName?.length > 15
                ? '12.5rem'
                : `${45 + user?.fullName?.length * 10}px`
              : '8rem',
        }}
      >
        <Badge
          style={{
            background: '#FFFFFF',
            color: '#0E9347',
            fontWeight: 'bold',
            fontSize: '13px',
            minWidth: '1rem',
            maxWidth: '1.85rem',
            height: '1rem',
            lineHeight: '1rem',
          }}
          overflowCount={9}
          count={markUnreadNotifications ? markUnread : totalNotifications}
        >
          <Popover
            content={listNotifcations}
            placement="bottomLeft"
            trigger="click"
            className="popover-head-notification"
            key={keyNotification}
            visible={visibleNotification}
            onVisibleChange={setVisibleNotification}
          >
            <svg
              style={{ cursor: 'pointer' }}
              width="17"
              height="21"
              viewBox="0 0 17 21"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M11.4595 17.3226C13.0853 17.3226 14.7111 17.3226 16.3369 17.3226C16.6211 17.3226 16.7947 17.1935 16.8578 16.9355C17.0472 16.1774 17.142 15.371 16.7316 14.6774C16.4474 14.1774 16.0212 13.7419 15.6109 13.3387C15.0268 12.7742 14.6322 12.1129 14.5375 11.3065C14.427 10.3871 14.3954 9.45161 14.3954 8.51613C14.4112 7.33871 14.2534 6.19355 13.7798 5.12903C13.1485 3.70968 12.1698 2.66129 10.6703 2.20968C10.3862 2.12903 10.0862 2.09678 9.80212 2.04839C9.77055 1.67742 9.77055 1.32258 9.70742 0.983872C9.59692 0.338711 9.12339 -0.0322571 8.50779 -0.0322571C7.86062 -0.0322571 7.43444 0.322582 7.30816 0.967743C7.24502 1.32258 7.24502 1.67742 7.21345 2.04839C7.1661 2.06452 7.13453 2.08065 7.10296 2.08065C5.82441 2.16129 4.84576 2.79032 4.05653 3.75807C3.1726 4.83871 2.77798 6.1129 2.65171 7.48387C2.62014 7.83871 2.68327 8.22581 2.71484 8.58065C2.68327 8.69355 2.62014 8.79032 2.62014 8.90323C2.60435 9.5 2.60435 10.0806 2.57278 10.6774C2.50964 11.7419 2.16238 12.6774 1.34158 13.371C1.10482 13.5645 0.899616 13.7903 0.694417 14.0161C-0.079028 14.8548 -0.0948126 15.8548 0.141956 16.8871C0.18931 17.1129 0.331371 17.2903 0.599709 17.2903C4.04075 17.2903 7.48179 17.2903 10.907 17.2903"
                fill="#0E9347"
              />
              <path
                d="M10.4653 18.4194C9.80239 18.4355 9.15523 18.4194 8.49227 18.4194C7.97138 18.4194 7.45049 18.4194 6.9296 18.4194C6.17194 18.4194 6.17194 18.4194 6.23508 19.1935C6.29822 20.2097 6.89803 20.8548 7.89246 20.9516C8.22394 20.9839 8.55541 21 8.88689 20.9839C9.67612 20.9516 10.3391 20.6613 10.6232 19.8387C10.7495 19.4839 10.7337 19.0806 10.781 18.7097C10.8126 18.4677 10.6863 18.4032 10.4653 18.4194Z"
                fill="#0E9347"
              />
            </svg>
          </Popover>
        </Badge>
      </div>
      <Popover
        className="header-popover"
        content={
          <div className="header-popover-content">
            <Link style={{ color: 'rgba(255, 255, 255, 0.65)' }} to="/settings">
              <div className="child-btn">
                <div className="icon-logout">
                  <UserOutlined />
                </div>
                <div className="text text-logout"> {t('Account Settings')}</div>
              </div>
            </Link>
            <div className="child-btn language">
              <div className="icon">
                <TranslationOutlined />
              </div>
              <div className="text text-language">{t('Language')}</div>
              <Select
                value={language}
                onChange={(value) => handleUpdateLanguage(value)}
              >
                <Option value="vi">{t('Vietnamese')}</Option>
                <Option value="en">{t('English')}</Option>
              </Select>
            </div>
            <div className="child-btn" onClick={() => functionLogout()}>
              <div className="icon-logout">
                <LogoutOutlined />
              </div>
              <div className="text text-logout">{t('Logout')}</div>
            </div>
          </div>
        }
        trigger="click"
        placement="bottomRight"
        visible={visibleUserControl}
        onVisibleChange={() => setVisibleUserControl((state) => !state)}
      >
        <div className="header-user-control">
          <div className="name" title={user?.fullName ?? ''}>
            {user?.fullName?.length > 15
              ? user?.fullName.substring(0, 15) + '..'
              : user?.fullName ??
                'User' ?? <LoadingOutlined style={{ fontSize: '20px' }} />}
          </div>
          <div className="icon-down">
            <CaretDownOutlined />
          </div>
        </div>
      </Popover>
      <MenuOutlined
        className="menu-mobile"
        onClick={showDrawer}
        style={{
          fontSize: 24,
          position: 'absolute',
          top: 20,
          right: 16,
          display: 'none',
        }}
      />
      <Modal
        className="modal-detail-notification"
        title={
          <div style={{ display: 'flex' }}>
            <div>{contentNotification(notificationDetail ?? '')}</div>
            <div
              style={{
                color: '#797979',
                marginLeft: '8px',
                fontSize: '12px',
                marginTop: '3px',
              }}
            >
              {moment(notificationDetail?.updatedAt).format(
                'HH:mm:ss DD-MM-YYYY'
              )}
            </div>
          </div>
        }
        visible={isModalVisible}
        onCancel={handleCancel}
        style={{ top: 50 }}
        width="920px"
        bodyStyle={{ textAlign: 'center' }}
        footer={[
          <Button key="back" onClick={handleCancel}>
            {t('Close')}
          </Button>,
        ]}
      >
        {notificationDetail && (
          <img
            alt=""
            src={
              notificationDetail.extraInfo &&
              JSON.parse(notificationDetail.extraInfo) &&
              JSON.parse(notificationDetail.extraInfo).imageUrl
            }
            style={{ width: '850px', height: '478px', objectFit: 'cover' }}
          />
        )}
      </Modal>
      <StepsIntro
        enabled={stepsEnabled}
        steps={dataSteps}
        initialStep={initialStep}
        onExit={() => setStepsEnabled(false)}
      />
      <Modal
        className="intro-start"
        width="600px"
        title=""
        visible={isModalVisibleStart}
        onOk={handleOkStart}
        onCancel={handleCancelStart}
        maskClosable={false}
        footer={[
          <Button type="primary" onClick={handleOkStart}>
            {t('Bắt đầu')}
          </Button>,
        ]}
      >
        <div className="intro-start-content">
          <img alt="" style={{ width: '100%' }} src={IntroStart} />
          <div className="title-content">
            {t('Chào mừng đến với cloud camera')}
          </div>
          <div className="title-description">
            {t(
              'Giải pháp giúp bạn quản lý và khai thác hiệu quả cho các hệ thống camera lớn'
            )}
          </div>
        </div>
      </Modal>
    </Header>
  );
});

export default AppHeader;
